import { useAppStore } from '@store'
import { motion } from 'framer-motion'
import { createPortal } from 'react-dom'

export function SpinnerPDFViewer() {
  const spinnerContent = (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className='pointer-events-none fixed inset-0 z-[9999] flex items-center justify-center bg-black/20'
    >
      <div
        aria-label='Loading...'
        role='status'
        className='flex h-[146px] w-[1000px] items-center justify-evenly space-x-2 border-2 border-colorAtemporal bg-white px-8 py-8'
      >
        <svg
          className='ml-4 mr-6 h-16 w-16 animate-spin stroke-colorAtemporal'
          viewBox='0 0 256 256'
        >
          <line
            x1='128'
            y1='32'
            x2='128'
            y2='64'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='195.9'
            y1='60.1'
            x2='173.3'
            y2='82.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='224'
            y1='128'
            x2='192'
            y2='128'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='195.9'
            y1='195.9'
            x2='173.3'
            y2='173.3'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='128'
            y1='224'
            x2='128'
            y2='192'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='60.1'
            y1='195.9'
            x2='82.7'
            y2='173.3'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='32'
            y1='128'
            x2='64'
            y2='128'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
          <line
            x1='60.1'
            y1='60.1'
            x2='82.7'
            y2='82.7'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='24'
          ></line>
        </svg>
        <span className='flex-grow text-center text-2xl font-medium text-C/Color3'>
          {'Estamos generando tu presupuesto actualizado'}
        </span>
      </div>
    </motion.div>
  )

  // Renderizar en un portal para asegurar que esté en la raíz del DOM y centrado correctamente
  if (typeof document !== 'undefined') {
    return createPortal(spinnerContent, document.body)
  }
  return spinnerContent
}
